export const inputStyle = {
  label: 'group-data-[filled-within=true]:text-chDarkBlue text-lg',
  input: 'placeholder:text-chLightText',
  inputWrapper: 'bg-chOffWhite border-1 data-[hover=true]:bg-chOffWhite-200 group-data-[focus=true]:bg-chOffWhite-200',
}

export const inputStyleInside = {
  label: 'group-data-[filled-within=true]:text-chTan-600',
  input: 'placeholder:text-chLightText',
  inputWrapper: 'bg-chOffWhite border-1 data-[hover=true]:bg-chOffWhite-200 group-data-[focus=true]:bg-chOffWhite-200',
}

export const selectStyle = {
  trigger: 'bg-chOffWhite border-1 data-[hover=true]:bg-chOffWhite-200 text-primary',
  inputWrapper: 'group-data-[focus=true]:bg-chOffWhite-200'
}

export const calendarStyle = {
  label: 'group-data-[filled-within=true]:text-chDarkBlue text-xl',
  inputWrapper: 'h-16 bg-chOffWhite hover:bg-chOffWhite-200 border-1 data-[hover=true]:bg-chOffWhite-200 focus-within:hover:bg-chOffWhite-200',
  innerWrapper: 'data-[hover=true]:bg-chOffWhite-200',
  selectorIcon: 'text-primary text-xl',
  gridHeaderRow: '',
  gridWrapper: '',
  grid: '',
  gridHeader: '',
  gridHeaderRow: '',
  gridHeaderCell: '',
  gridBody: '',
  gridBodyRow: '',
  pickerWrapper: '',
  pickerMonthList: '',
  pickerYearList: '',
  pickerItem: '',
}

export const textAreaStyle = {
  label: 'group-data-[filled-within=true]:text-gray-400',
  input: 'placeholder:text-chLightText text-md',
  inputWrapper: 'bg-chOffWhite border-1 data-[hover=true]:bg-chOffWhite-200 group-data-[focus=true]:bg-chOffWhite-200'
}

export const menuContainerClass = 'grid grid-cols-1 md:grid-cols-2 gap-2 bg-chTan-300 text-chTan-600 rounded-md p-2'
export const menuItemClasses = {
  separator: 'pl pr md:pl-2 md:pr-2',
  item: 'data-[current=false]:text-info hover:text-primary data-[current=true]:text-secondary data-[current=true]:font-bold'
}